import { FC } from "react";

import { ScheduleSummarySegment } from "./ScheduleSummarySegment";
import { formatShopIdleSummary, getIdleThumbnailUrl } from "./helpers";
import { ThumbnailedSummaryLayout } from "./ThumbnailedSummaryLayout";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { useTicketingTaxes } from "@/features/LiveFormEditor/Steps/StepTickets/hooks/useTicketingTaxes";
import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

interface ShopIdleSummaryProps {
  title: string;
  rate: Partial<RateData>;
  isExpanded: boolean;
}

export const ShopIdleSummary: FC<ShopIdleSummaryProps> = ({ title, rate, isExpanded }) => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  const { organizationCurrency } = useCurrentUserContext();
  const { taxes } = useTicketingTaxes();

  const thumbnailUrl = getIdleThumbnailUrl(rate);
  const taxRatePpmById = new Map(taxes.map((tax) => [tax.id, tax.ratePpm]));
  const subtitle = formatShopIdleSummary(rate, { locale, currency: organizationCurrency, t, taxRatePpmById });

  return (
    <ThumbnailedSummaryLayout
      title={title}
      thumbnailUrl={thumbnailUrl}
      subtitle={subtitle}
      subtitleTrailing={<ScheduleSummarySegment rate={rate} withSeparator={Boolean(subtitle)} />}
      isExpanded={isExpanded}
    />
  );
};
